// KWANKGM04050_借入申込内容照会画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import FileUpload from '../../templates/FileUpload';
import Agreement from '../../templates/Agreement';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import MypageReturn from '../../molecules/MypageReturn';
import Annotation from '../../atoms/Annotation';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_cd: string;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  agreements: {
    guarantor: string;
    title: string;
    text: string;
  };
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  setDisplayStatus: (flag: boolean) => void;
  moveStepNav: VoidFunction;
  requestModule: (module_name: string) => Promise<any>;
  is_loading: boolean;
  is_disagree: boolean;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const ContentInquiryGuarantorDisagreement: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  agreements,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  setDisplayStatus,
  moveStepNav,
  requestModule,
  is_loading,
  is_disagree,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={requestModule}
        guarantor_info={guarantor_info}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={true} // 提出書類を編集不可にするためtrueを渡す
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <Agreement
        guarantor={agreements.guarantor}
        title={agreements.title}
        text={agreements.text}
        is_disagree={is_disagree}
      />
      <Annotation
        text={
          '※他の連帯債務者等で既に不同意を表明されている方がいらっしゃる場合、同意・不同意のどちらも選択できません。'
        }
      />
      <MypageReturn is_staff={false} />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ContentInquiryGuarantorDisagreement;
